
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="语言切换" fileName="switch-lang.md" />
        <p>你可以通过 VeLocal 组件实现多语言支持，使用 <code>VeLocal.use</code> 方法可以切换当前使用的语言</p>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;div&gt;
            &lt;button class=&quot;button-demo&quot; @click=&quot;englishLang()&quot;&gt;英文&lt;/button&gt;
            &lt;button class=&quot;button-demo&quot; @click=&quot;chineseLang()&quot;&gt;中文&lt;/button&gt;
            &lt;br /&gt;
            &lt;br /&gt;
        &lt;/div&gt;
        &lt;div&gt;
            &lt;ve-pagination :total=&quot;600&quot; /&gt;
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
    import zhCN from &quot;vue-easytable/libs/locale/lang/zh-CN&quot;;
    import enUS from &quot;vue-easytable/libs/locale/lang/en-US&quot;;

    export default {
        methods: {
            englishLang() {
                this.$veLocale.use(enUS);
            },
            chineseLang() {
                this.$veLocale.use(zhCN);
            },
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        import zhCN from "vue-easytable/libs/locale/lang/zh-CN";
import enUS from "vue-easytable/libs/locale/lang/en-US";
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('div',[_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.englishLang()}}},[_vm._v("英文")]),_vm._v(" "),_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.chineseLang()}}},[_vm._v("中文")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',[_c('ve-pagination',{attrs:{"total":600}})],1)])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        methods: {
            englishLang() {
                this.$veLocale.use(enUS);
            },
            chineseLang() {
                this.$veLocale.use(zhCN);
            },
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  